module.exports = __webpack_public_path__ + "fonts/Rubik-MediumItalic.a5b30b0.woff";